import theme from '../../theme';

export const S: { [key: string]: React.CSSProperties } = {
    subtitle: {
        marginBottom: '0.5rem',
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '12px',
        color: theme.color.white50
    }
};
